import ky from 'ky';

const kyOriginal = ky.create({
  timeout: 120000,
});

export default kyOriginal;
